import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

const ExplosionLegend = () => {
  const { t } = useTranslation();

  return (
    <div style={legendStyle}>
      <div>
        <b>{t("riskAssessment.explosion")} (ITA)</b>
      </div>
      <div>
        <span style={legendItemStyle("#fff5f0")}></span>
        {t("levels.low") + " 0.5 km"}
      </div>
      <div>
        <span style={legendItemStyle("#fca486")}></span>
        {t("levels.moderate") + " 1.0 km"}
      </div>
      <div>
        <span style={legendItemStyle("#ea372a")}></span>
        {t("levels.significant") + " 1.5 km"}
      </div>
      <div>
        <span style={legendItemStyle("#67000d")}></span>
        {t("levels.high") + " 2.0 km"}
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, {t("legend.dataFromISPRA")}
        </span>
      </div>
    </div>
  );
};

export default ExplosionLegend;
